module.exports = __webpack_public_path__ + "img/eu-flag.a07a8bb7.svg";